module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.7ad17c6085dee9a33787.eot";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.eot
// module chunks = 2